import TrackingProvider from './TrackingProvider';

class GoogleTagManager extends TrackingProvider {
    public initialize(trackingIds: string) {
        const ids = this.extractCleanTrackingIds(trackingIds);
        const debug = this.debug.bind(this);

        if (!this.isActive && ids.length > 0) {
            this._trackingIds = ids;

            window.dataLayer = window.dataLayer || [];
            /* eslint-disable */
            window.gtag = function () {
                window.dataLayer.push(arguments);
                debug('gtag:', ...arguments);
            };
            /* eslint-enable */
            this.trackingIds.forEach((id) => this.loadScript(`https://www.googletagmanager.com/gtm.js?id=${id}`));
            this._active = true;

            this.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        }

        return this;
    }

    public push(data: object) {
        if (this.isActive) {
            window.dataLayer.push(data);
            this.debug('GTM.push:', data);
        }
    }

    public static readonly gtag: Gtag.Gtag = (...args) => {
        window.gtag?.(...args);
    };
}

export default new GoogleTagManager().initialize(
    window.IS_CASINO
        ? process.env.MIX_CASINO_GOOGLE_TAG_MANAGER_ID : process.env.MIX_GOOGLE_TAG_MANAGER_ID
);
export { GoogleTagManager };
